//convert "123 Fake St, Brooklyn, NY" to '123 Fake St'
export const shortAddress = (longAddress='') => {
	// const [streetAddress, ...rest] = longAddress.split(',');
	const [streetAddress] = longAddress.split(',');
	return streetAddress;
}

//decode the :address route param. Older backend emails built links with PHP urlencode(), which
//writes spaces as "+", and decodeURIComponent() leaves "+" alone. NYC addresses never contain a
//literal "+" (a real one arrives as %2B and still decodes to "+"), so it is safe to read it as a space.
export const decodeAddressParam = (address = '') => {
	return decodeURIComponent(String(address).replace(/\+/g, ' '));
}